export default "__VITE_ASSET__fa3b968c__"